module.exports = {
	new: {
		1: '首頁',
		2: '關於',
		3: '服務',
		4: '常見疑問',
		5: '夥伴',
		6: '語言',
		7: '一體化綜合服務平台',
		8: '致力於',
		'8_2': '驅動',
		'8_3': '加密貨幣',
		'8_4': '發展',
		9: '最優質 / 最專業 / 最高效',
		10: '了解更多',
		11: '我們的工具',
		12: '團隊成員',
		13: '成功項目',
		14: '綜合經驗',
		15: '關於',
		'15_2': 'Block Change',
		16: 'Block Change 成立於 2019年，總部設立在',
		'16_2':'中國香港，',
		'16_3':'一家營銷及開發為一體的加密機構，',
		'16_4':'專注於幫助項目解決各類需求和問題。',
		17: '我們團隊深耕區塊鏈行業多年，通過我們的各種服務使 您的加密貨幣令牌達到',
		'17_2':'新的高度，幫助',
		'17_3':'多個區塊鏈客戶',
		'17_4':'走向成功.',
		18: 'Block Change 的願景',
		19: '推動加密貨幣行業發展，',
		20: '讓普通人也可以輕鬆參與進來',
		21: '我們提供 ',
		'21_2': '專業服務',
		22: '由經驗豐富的人員組成',
		23: '品牌搭建',
		24: '選擇項目賽道、整體形象設計',
		25: '内容創作',
		26: '创意的内容故事增加知名度',
		27: '創建合約',
		28: '智能合約開發及網站製作',
		29: '顧問咨詢',
		30: '為項目提供建議和製定相關戰略',
		31: '社交平臺',
		32: 'Telegram / Discord / Twitter 平臺搭建營銷',
		33: '媒體 KOL 推廣',
		34: '意見領袖及行業媒體提高影響力',
		35: '上市安全列表',
		36: '交易所、審計、Coinmarketcap',
		37: '活動策劃',
		38: '線上線下舉辦活動促進增長',
		39: '創意出版物 ',
		40: '广告设计和制作(视频、 GIF、 PNG)',
		41: '軟件開發 ',
		'41_2': '服務',
		42: '成熟的技術團隊運作',
		43: '合約測試',
		44: 'IDO',
		45: 'DEFI',
		46: '流動池',
		47: 'DEX',
		48: 'NFT',
		49: '智能合約',
		50: 'Token',
		51: 'Farm',
		52: '部署',
		53: '我們服務的人群',
		54: '全球分佈',
		55: '合作夥伴',
		56: '常見問題解答',
		57: '這裏有我們被問到的一些最常見的問題。',
		58: '區塊鏈',
		'58_2': '一體化服務平臺',
		59: '社交媒體',
		60: '聯係我們 / ',
        '60_2': 'Support@BlockChange.Dev',
		q1: '品牌搭建及開發的費用是多少？',
		q2: '項目發射整體時間需要多久？',
		q3: '項目發射后還有那些支持?',
		q4: 'BlockChange 有沒有自己的平臺?',
		a1: '取決幹客戶的項目需求，請聯系我們討論後給予報價。',
		a2: '通常需要1-3周的時間，同時每個項目需求不同，時間會上下波動是正常的。具體時間需要與我們溝通後確認，我們會給出詳細的計劃表。',
		a3: '上市DEX交易所及CMC,CG等平台，KOL相關推廣服務求。', 
		a4: '我們擁有自己的工具類平台，可以讓所有人輕鬆參與進來。',

	},
	ball: {
		1: '合約測試',
		2: 'IDO',
		3: 'DEFI',
		4: '流動池',
		5: 'DEX',
		6: 'NFT',
		7: '智能合約',
		8: 'Token',
		9: 'Farm',
		10: '部署',
	},
	tip: {
		1: "購買成功",
		2: "購買失敗",
		3: "領取成功",
		4: "領取失敗",
		5: "參入成功",
		6: '參入失敗',
		7: "預售未開放",
		8: "請選擇預售金額",
		9: "餘額不足",
		10: "授權失敗",
		11: "未開放領取"
	},



}